module.exports = require('./helpers/bundle-url').getBundleURL('9OGKF') + "logo.c51670a8.svg";